import { ReportsData } from '../interfaces';

export const getFooterInfoProps = (isLoading: boolean, limits: ReportsData['limits']) => ({
  label: 'Reports limits',
  value:
    isLoading || !limits
      ? '-'
      : // eslint-disable-next-line max-len
        `${limits.activeLimit.itemsCount} of ${limits.activeLimit.limit} active including ${limits.pendingLimit.itemsCount} of ${limits.pendingLimit.limit} pending`,
  tooltip:
    // eslint-disable-next-line max-len
    'If you reach the limit of the active or pending reports you will be unable to create, restore or retry reports. Delete or cancel pending report to bring back reports generation permission.'
});
